/** Id helpers. Assignment ids are deterministic (the security rules rely on it). Response ids are opaque and
assigned by the backend (`startAttempt` returns them) - never construct them client-side. */

export function newId(): string {
  return crypto.randomUUID();
}

/** quizAssignments doc id: `{quizId}_{lowercased trimmed email}` */
export function getQuizAssignmentId(quizId: string, email: string): string {
  return `${quizId}_${email.trim().toLowerCase()}`;
}
